import FormattedMessage from 'I18n/components/FormattedMessage';
import { Body, Button, LayoutBox, LayoutSpaceVertical } from 'breeze-intelligence-kit';
import { ErrorCodeMessage } from './ErrorCodeMessage';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export const ErrorAlertMessage = ({
  children,
  errorId,
  onSubmit
}) => {
  const showButton = !!onSubmit;
  return /*#__PURE__*/_jsxs(LayoutSpaceVertical, {
    gap: "space",
    children: [/*#__PURE__*/_jsx(Body, {
      as: "div",
      children: children
    }), /*#__PURE__*/_jsx(LayoutBox, {
      children: errorId ? /*#__PURE__*/_jsx(ErrorCodeMessage, {
        errorId: errorId
      }) : null
    }), showButton ? /*#__PURE__*/_jsx(Button, {
      onClick: onSubmit,
      children: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "enrichmentProperties.panel.error.retry"
      })
    }) : null]
  });
};